var _path, _g, _path2, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _g4, _path8, _g5, _path9, _g6, _path10, _g7, _path11, _g8, _path12, _g9, _path13, _g10, _path14, _g11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoHack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 344,
    viewBox: "0 0 289 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_252_3059)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_252_3059",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 289,
    height: 193
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.692993 0H288.386V192.613H0.692993V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_252_3059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.419 64.0043V31.7304L224.455 31.7114V95.7155H192.487V63.7134H160.523V31.7114H224.455V0.00341797H64.6245V31.7114H128.556V95.7155H96.5918V63.7134H64.6245V31.7114H32.6571V64.0043H0.692993V192.009H32.6571V160.007H64.6245V192.009H96.5918V160.007H128.556V192.009H160.523V160.007H192.487V192.009H224.455V160.007H256.419V192.009H288.386V64.0043",
    fill: "#2DAB66"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9929 279.919H16.9056V263.935H48.9929V279.919ZM16.9056 231.968H32.8719V247.951H16.9056V231.968ZM48.8382 247.951V215.987H0.939331V295.902H64.8045V247.951",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7676 215.987V295.902H136.65V279.919H96.7339V263.935H128.666V247.951H96.7339V231.968H136.65V215.987",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_252_3059",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 223,
    y: 215,
    width: 66,
    height: 82
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M223.817 215.273H288.386V296.203H223.817V215.273Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_252_3059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.461 215.987V231.968H248.41V295.902H264.377V231.968H288.323V215.987",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M167.862 247.923L167.891 231.908L208.495 231.968V215.987H152.616V247.951L152.594 263.963L192.528 263.935V279.919H152.616V295.902H208.495V247.958",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_252_3059",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 227,
    y: 311,
    width: 29,
    height: 33
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M227.859 311.58H255.345V343.847H227.859V311.58Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_252_3059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.826 318.399H234.765V337.427H247.826V318.399ZM227.957 311.886H254.575V343.847H227.957V311.886Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_252_3059",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 311,
    width: 29,
    height: 33
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8381 311.58H61.3244V343.847H33.8381V311.58Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_252_3059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.0065 324.503H54.2318V318.335H41.0065V324.503ZM34.2455 343.847V311.896H60.8318V343.809H54.4812V331.236H40.956V343.847",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_252_3059",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 133,
    y: 311,
    width: 28,
    height: 33
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M133.274 311.58H160.76V343.847H133.274V311.58Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_252_3059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.518 324.522H153.81V318.402H140.518V324.522ZM140.509 343.847H133.931V311.886H160.457V343.724H153.945V331.173H140.509",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_252_3059",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 311,
    width: 28,
    height: 33
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0.692993 311.58H27.3708V343.847H0.692993V311.58Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_252_3059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6887 324.544V311.927H27.3582V343.797H20.7393V331.18H7.36561V343.847H0.692993V311.893H7.20772V324.544",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_252_3059",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 193,
    y: 311,
    width: 29,
    height: 33
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M193.905 311.58H221.392V343.847H193.905V311.58Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_252_3059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.868 331.208V343.815H194.382V311.889H200.783V324.538H214.324V311.93H220.908V343.847H214.406V331.208",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_252_3059",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 67,
    y: 311,
    width: 29,
    height: 33
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7919 311.58H95.2781V343.847H67.7919V311.58Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_252_3059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.9308 311.886H94.5297V318.209H74.7392V337.556H94.6023V343.847H67.9308",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_252_3059",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 167,
    y: 311,
    width: 21,
    height: 33
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M167.227 311.58H187.438V343.847H167.227V311.58Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_252_3059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.464 311.886H187.384V318.158H180.888V343.847H174.118V318.263H167.464",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_252_3059",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 100,
    y: 311,
    width: 30,
    height: 33
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M100.937 311.58H129.232V343.847H100.937V311.58Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_252_3059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.843 343.847L113.449 327.955L127.002 311.883H119.098L108.099 324.923V311.88H101.493V343.847H108.099V330.731L120.709 343.847",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_252_3059",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 261,
    y: 311,
    width: 28,
    height: 33
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M261.004 311.58H288.386V343.847H261.004V311.58Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_252_3059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.317 311.886H281.758V332.454L269.609 311.886H261.68V343.847H268.239V322.951L280.58 343.847H288.317",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_252_3059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 287.692,
    height: 343.846,
    fill: "white",
    transform: "translate(0.692993)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHack);
export default __webpack_public_path__ + "static/media/logo-hack.d524cd6a00fded7760e29be781e75573.svg";
export { ForwardRef as ReactComponent };